import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  iconButtonText: { fontSize: 14, fontWeight: 700, marginLeft: '10px', color: '#E8192C' },
  icon: { width: '24px', height: '24px', color: '#E8192C' },
}));
